module.exports = __webpack_public_path__ + "static/media/mz.e99caf39.svg";